import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const SharedConversationPreviewLoadable: ComponentType<RouteContext> &
	LoadableExport.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "shared-conversation-preview-view" */ './SharedConversationPreviewView'
		),
	loading: () => null,
});
